import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { useCart } from "./context/CartContext";
import ProductsPage from "./pages/ProductsPage";
import CartPage from "./pages/CartPage";

const Navbar = () => {
  const { cart } = useCart();
  return (
    <nav style={{
      padding: "16px 60px", background: "#1a1a2e",
      display: "flex", justifyContent: "space-between", alignItems: "center",
      boxShadow: "0 2px 20px rgba(0,0,0,0.2)"
    }}>
      <Link to="/" style={{ color: "#fff", textDecoration: "none", fontSize: "1.4rem", fontWeight: "700" }}>
        ⚡ ShopZone
      </Link>
      <Link to="/cart" style={{
        color: "#fff", textDecoration: "none", background: "#667eea",
        padding: "10px 20px", borderRadius: "10px", fontWeight: "600", fontSize: "0.95rem"
      }}>
        🛒 Cart {cart.length > 0 && `(${cart.length})`}
      </Link>
    </nav>
  );
};

function App() {
  return (
    <CartProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<ProductsPage />} />
          <Route path="/cart" element={<CartPage />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;